import React from 'react'
import MoveCursorToTop from '../../services/MoveCursorToTop'

const Owners = () => {
    MoveCursorToTop();
  return (
    <section className="enquiry--block">
        <center><h2>Coming soon</h2></center>
    </section>
  )
}

export default Owners